/* dcnt. size picker: tapping a card's + opens a bottom sheet (5 ml / 10 ml / full bottle) then adds to cart */
(function () {
  var CSS = '' +
    'html.d-lock-size,html.d-lock-size body{overflow:hidden}' +
    '.d-sz{position:fixed;inset:0;z-index:220;visibility:hidden;pointer-events:none;transition:visibility 0s linear .45s;font-family:var(--d-font)}' +
    '.d-sz.is-open{visibility:visible;pointer-events:auto;transition:none}' +
    '.d-sz__scrim{position:absolute;inset:0;background:rgba(0,0,0,.42);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);opacity:0;transition:opacity .35s ease}' +
    '.d-sz.is-open .d-sz__scrim{opacity:1}' +
    '.d-sz__panel{position:absolute;left:0;right:0;bottom:0;max-height:90vh;max-height:90dvh;display:flex;flex-direction:column;background:#fff;border-radius:24px 24px 0 0;box-shadow:0 -10px 40px rgba(0,0,0,.18);transform:translateY(100%);transition:transform .45s cubic-bezier(.22,1,.36,1);outline:none;overflow:hidden}' +
    '.d-sz.is-open .d-sz__panel{transform:translateY(var(--drag,0px))}' +
    '.d-sz__panel.is-dragging{transition:none}' +
    '@media (min-width:750px){.d-sz__panel{left:50%;right:auto;width:480px;margin-left:-240px}}' +
    '.d-sz__grab{flex:none;width:40px;height:5px;margin:8px auto 0;border-radius:999px;background:#D2D2D7}' +
    '.d-sz__head{flex:none;display:flex;align-items:center;gap:14px;padding:10px 10px 14px 18px;touch-action:none}' +
    '.d-sz__img{flex:none;width:64px;height:64px;border-radius:16px;background:var(--t,#F5F5F7);display:flex;align-items:center;justify-content:center;overflow:hidden}' +
    '.d-sz__img img{width:100%;height:100%;object-fit:contain;padding:6px;box-sizing:border-box}' +
    '.d-sz__ttl{flex:1 1 auto;min-width:0}' +
    '.d-sz__brand{font-size:12px;color:var(--d-muted)}' +
    '.d-sz__name{font-size:19px;font-weight:600;letter-spacing:-.02em;color:var(--d-ink);line-height:1.2;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.d-sz__x{flex:none;align-self:flex-start;width:44px;height:44px;border:0;border-radius:999px;background:none;color:var(--d-ink);display:flex;align-items:center;justify-content:center;cursor:pointer}' +
    '.d-sz__body{flex:1 1 auto;min-height:0;overflow-y:auto;overscroll-behavior:contain;padding:2px 16px 8px}' +
    '.d-sz__lbl{margin:0 2px 10px;font-size:13px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:var(--d-muted)}' +
    '.d-sz__opts{display:flex;flex-direction:column;gap:10px}' +
    '.d-sz__opt{position:relative;display:flex;align-items:center;gap:12px;width:100%;min-height:64px;padding:12px 16px;border:1.5px solid var(--d-line);border-radius:16px;background:#fff;color:var(--d-ink);text-align:left;cursor:pointer;font:inherit;transition:border-color .2s,background .2s,transform .15s}' +
    '.d-sz__opt:active{transform:scale(.99)}' +
    '.d-sz__opt[aria-checked="true"]{border:2px solid var(--d-brand);padding:11.5px 15.5px;background:var(--d-brand-tint,#F3EEFF)}' +
    '.d-sz__opt[disabled]{opacity:.4;cursor:default}' +
    '.d-sz__dot{flex:none;width:20px;height:20px;border-radius:50%;border:1.5px solid var(--d-line);display:flex;align-items:center;justify-content:center;transition:border-color .2s}' +
    '.d-sz__opt[aria-checked="true"] .d-sz__dot{border-color:var(--d-brand)}' +
    '.d-sz__opt[aria-checked="true"] .d-sz__dot::after{content:"";width:10px;height:10px;border-radius:50%;background:var(--d-brand)}' +
    '.d-sz__main{flex:1 1 auto;min-width:0}' +
    '.d-sz__t{display:block;font-size:16px;font-weight:600;letter-spacing:-.01em}' +
    '.d-sz__s{display:block;margin-top:2px;font-size:13px;color:var(--d-muted)}' +
    '.d-sz__p{flex:none;text-align:right}' +
    '.d-sz__p b{display:block;font-size:16px;font-weight:600}' +
    '.d-sz__p small{display:block;margin-top:2px;font-size:12px;color:var(--d-muted)}' +
    '.d-sz__tag{position:absolute;top:-9px;right:14px;padding:3px 9px;border-radius:999px;background:var(--d-brand);color:#fff;font-size:10px;font-weight:700;letter-spacing:.06em}' +
    '.d-sz__off{color:#0F8A4F !important;font-weight:600}' +
    '.d-sz__foot{flex:none;padding:12px 16px calc(12px + env(safe-area-inset-bottom));border-top:1px solid var(--d-line-2)}' +
    '.d-sz__cta{width:100%;height:52px;border:0;border-radius:14px;background:var(--d-brand);color:#fff;font:600 16px/1 var(--d-font);display:flex;align-items:center;justify-content:center;gap:8px;cursor:pointer;transition:background .2s,transform .15s}' +
    '.d-sz__cta:active{transform:scale(.98)}' +
    '.d-sz__cta[disabled]{opacity:.5;cursor:default}' +
    '.d-sz__cta.is-done{background:#1E9E5A}' +
    '.d-sz__err{margin:10px 2px 0;font-size:13px;color:#C4302B}' +
    '.d-sz__load{padding:28px 0;text-align:center;color:var(--d-muted);font-size:14px}' +
    '.d-card__add{flex:none;width:36px;height:36px;padding:0;border:0;border-radius:50%;background:var(--d-brand);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 8px 16px -8px rgba(106,60,240,.7);transition:transform .2s ease,background .2s ease}' +
    '.d-card__add:hover{background:var(--d-brand-ink)}' +
    '.d-card__add:active{transform:scale(.9)}' +
    '.d-card__add:disabled{opacity:.35;box-shadow:none;cursor:default}' +
    '@media (max-width:749px){.d-card__add{width:34px;height:34px}}' +
    '@media (prefers-reduced-motion:reduce){.d-sz__panel,.d-sz__scrim{transition:none}}';

  var cache = {};
  var sheet, panel, state = null, lastTrigger = null;

  function money(cents) {
    var v = cents / 100;
    return '₱' + v.toLocaleString('en-PH', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function ml(title) { var m = String(title).match(/([\d.]+)\s*ml/i); return m ? parseFloat(m[1]) : 0; }
  function handleFrom(url) { var m = String(url || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }

  function load(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('load'); return r.json(); })
        .catch(function (e) { delete cache[handle]; throw e; });
    }
    return cache[handle];
  }

  function build() {
    sheet = document.createElement('div');
    sheet.className = 'dcnt d-sz';
    sheet.setAttribute('aria-hidden', 'true');
    sheet.setAttribute('inert', '');
    sheet.innerHTML =
      '<div class="d-sz__scrim" data-sz-close></div>' +
      '<div class="d-sz__panel" role="dialog" aria-modal="true" aria-labelledby="d-sz-name" tabindex="-1">' +
        '<div class="d-sz__grab" data-sz-grab aria-hidden="true"></div>' +
        '<div class="d-sz__head" data-sz-grab>' +
          '<div class="d-sz__img" data-sz-img></div>' +
          '<div class="d-sz__ttl"><div class="d-sz__brand" data-sz-brand></div><div class="d-sz__name" id="d-sz-name" data-sz-name></div></div>' +
          '<button type="button" class="d-sz__x" data-sz-close aria-label="Close"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '</div>' +
        '<div class="d-sz__body"><p class="d-sz__lbl">Choose your size</p><div class="d-sz__opts" role="radiogroup" aria-label="Size" data-sz-opts></div><p class="d-sz__err" data-sz-err hidden></p></div>' +
        '<div class="d-sz__foot"><button type="button" class="d-sz__cta" data-sz-add disabled>Add to cart</button></div>' +
      '</div>';
    document.body.appendChild(sheet);
    panel = sheet.querySelector('.d-sz__panel');

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-sz-close]')) { close(); return; }
      var o = e.target.closest('.d-sz__opt');
      if (o && !o.disabled) { select(+o.getAttribute('data-vid')); return; }
      if (e.target.closest('[data-sz-add]')) addToCart();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) close(); });

    // drag down to dismiss
    var y0 = null, dy = 0, t0 = 0;
    sheet.querySelectorAll('[data-sz-grab]').forEach(function (h) {
      h.addEventListener('pointerdown', function (e) {
        if (e.target.closest('button')) return;
        y0 = e.clientY; dy = 0; t0 = Date.now(); panel.classList.add('is-dragging');
        try { h.setPointerCapture(e.pointerId); } catch (_) {}
      });
      h.addEventListener('pointermove', function (e) { if (y0 === null) return; dy = Math.max(0, e.clientY - y0); panel.style.setProperty('--drag', dy + 'px'); });
      function end() {
        if (y0 === null) return; y0 = null; panel.classList.remove('is-dragging');
        if (dy > 100 || dy / Math.max(1, Date.now() - t0) > 0.6) close(); else panel.style.removeProperty('--drag');
      }
      h.addEventListener('pointerup', end); h.addEventListener('pointercancel', end);
    });
  }

  function render(p) {
    var vs = p.variants.slice().sort(function (a, b) { return ml(a.title) - ml(b.title); });
    var base = vs[0], basePer = base ? base.price / (ml(base.title) || 1) : 0;
    var maxMl = Math.max.apply(null, vs.map(function (v) { return ml(v.title); }));
    var html = '';
    var pick = null;
    vs.forEach(function (v) {
      var m = ml(v.title), per = v.price / (m || 1);
      var full = vs.length > 2 && m === maxMl && m >= 30;
      var t = full ? 'Full bottle' : v.title;
      var sub = full ? v.title + ' bottle' : (v === base ? 'Try it first' : 'Decant');
      var off = v !== base && basePer ? Math.round((1 - per / basePer) * 100) : 0;
      var popular = !full && v !== base && m === 10;
      if (popular && v.available) pick = v.id;
      html += '<button type="button" class="d-sz__opt" role="radio" aria-checked="false" data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        (popular ? '<span class="d-sz__tag">MOST POPULAR</span>' : '') +
        '<span class="d-sz__dot" aria-hidden="true"></span>' +
        '<span class="d-sz__main"><span class="d-sz__t">' + t + '</span><span class="d-sz__s">' + (v.available ? sub : 'Sold out') + '</span></span>' +
        '<span class="d-sz__p"><b>' + money(v.price) + '</b>' + (off > 0 ? '<small class="d-sz__off">' + off + '% off per ml</small>' : '<small>' + money(Math.round(per)) + '/ml</small>') + '</span>' +
        '</button>';
    });
    sheet.querySelector('[data-sz-opts]').innerHTML = html;
    if (!pick) { var f = vs.filter(function (v) { return v.available; })[0]; pick = f ? f.id : null; }
    state.variants = vs;
    select(pick);
  }

  function select(vid) {
    state.vid = vid;
    sheet.querySelectorAll('.d-sz__opt').forEach(function (o) { o.setAttribute('aria-checked', +o.getAttribute('data-vid') === vid ? 'true' : 'false'); });
    var v = (state.variants || []).filter(function (x) { return x.id === vid; })[0];
    var btn = sheet.querySelector('[data-sz-add]');
    btn.classList.remove('is-done');
    btn.disabled = !v;
    btn.textContent = v ? 'Add to cart · ' + money(v.price) : 'Sold out';
  }

  function addToCart() {
    if (!state || !state.vid) return;
    var btn = sheet.querySelector('[data-sz-add]');
    var err = sheet.querySelector('[data-sz-err]');
    var dr = window.dcntDrawer;
    btn.disabled = true; btn.textContent = 'Adding…'; err.hidden = true;
    var p = dr ? dr.add(state.vid, 1) : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: state.vid, quantity: 1 }] }) }).then(function (r) { if (!r.ok) throw new Error(); });
    p.then(function () {
      btn.classList.add('is-done'); btn.textContent = 'Added ✓';
      setTimeout(function () {
        close(true);
        if (dr) dr.open(); else location.href = '/cart';
      }, 450);
    }).catch(function (e) {
      btn.disabled = false; select(state.vid);
      err.textContent = (e && (e.description || e.message)) || 'Couldn’t add that. Try again.';
      err.hidden = false;
    });
  }

  function open(handle, trigger) {
    if (!sheet) build();
    lastTrigger = trigger || null;
    state = { handle: handle, vid: null, variants: null };
    var card = trigger && trigger.closest('.d-card, .h-card');
    var img = card && card.querySelector('img');
    var media = card && card.querySelector('.d-card__media, .h-card__media');
    var box = sheet.querySelector('[data-sz-img]');
    box.innerHTML = img ? '<img alt="" src="' + (img.currentSrc || img.src) + '">' : '';
    box.style.setProperty('--t', media ? getComputedStyle(media).getPropertyValue('--t') || '#F5F5F7' : '#F5F5F7');
    var brand = card && card.querySelector('.d-card__brand, .h-card__brand');
    var name = card && card.querySelector('.d-card__title, .h-card__name');
    sheet.querySelector('[data-sz-brand]').textContent = brand ? brand.textContent.trim() : '';
    sheet.querySelector('[data-sz-name]').textContent = name ? name.textContent.trim() : '';
    sheet.querySelector('[data-sz-err]').hidden = true;
    sheet.querySelector('[data-sz-opts]').innerHTML = '<div class="d-sz__load">Loading sizes…</div>';
    var btn = sheet.querySelector('[data-sz-add]'); btn.disabled = true; btn.classList.remove('is-done'); btn.textContent = 'Add to cart';

    sheet.removeAttribute('inert'); sheet.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('d-lock-size');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); panel.focus({ preventScroll: true }); });

    load(handle).then(function (p) {
      if (!state || state.handle !== handle) return;
      if (!name) sheet.querySelector('[data-sz-name]').textContent = p.title;
      if (!brand) sheet.querySelector('[data-sz-brand]').textContent = p.vendor;
      render(p);
    }).catch(function () { location.href = '/products/' + handle; });
  }

  function close(keepFocus) {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    panel.style.removeProperty('--drag');
    sheet.setAttribute('aria-hidden', 'true'); sheet.setAttribute('inert', '');
    document.documentElement.classList.remove('d-lock-size');
    if (lastTrigger && !keepFocus) lastTrigger.focus({ preventScroll: true });
  }

  // capture phase so this runs before any older quick-add handlers
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-size-open], [data-quick-add]');
    if (!b) return;
    var handle = b.getAttribute('data-size-open') || handleFrom(b.getAttribute('data-url'));
    if (!handle) return;
    e.preventDefault(); e.stopPropagation();
    open(handle, b);
  }, true);

  // warm the cache on first touch so the sheet fills instantly
  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest && e.target.closest('[data-size-open], [data-quick-add]');
    if (!b) return;
    var h = b.getAttribute('data-size-open') || handleFrom(b.getAttribute('data-url'));
    if (h) load(h).catch(function () {});
  }, true);

  (function () { var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st); })();
  window.dcntSize = { open: open, close: close };
})();
